module.exports = __webpack_public_path__ + "img/plan-checked.c66af97b.svg";